import moment from '../../../utils/moment';

const formatTimestampAsIntToString = timestampAsInt => {
  return moment.unix(timestampAsInt).format('MM/DD/YYYY [às] hh:MM');
};

export default formatTimestampAsIntToString;
